import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionReportPage_ReportInfo_Update_Mutation = graphql(`
  mutation MissionReportPage_ReportInfo_Update(
    $missionId: Id!
    $reportInfoId: Id!
    $update: ReportInfoInput!
    $versionData: VersionDataInput
  ) {
    updateReportInfo(
      missionId: $missionId
      reportInfoId: $reportInfoId
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type UpdateInput = VariablesOf<
  typeof MissionReportPage_ReportInfo_Update_Mutation
>['update'];

export type ReportInfo_Update_Result = ResultOf<
  typeof MissionReportPage_ReportInfo_Update_Mutation
>;

export const useUpdateReportInfoMutation = () =>
  useGraphQLMutation(MissionReportPage_ReportInfo_Update_Mutation);
